import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  uploadedDocument: {},
  deleteDocument: [],
  documents: {},
  isAutofilled: false,
  multipleFileUpload: {},
  fileData: {},
  facematch: {},
  uploadVerificationResponses: {},
};
let maxFile = [];
let files = [];
let removeFiles = [];
export const uploadDocumentReducer = createSlice({
  name: "uploadDocument",
  initialState,
  reducers: {
    setUploadedDocument: (state, action) => {
      state.uploadedDocument = action.payload;
    },
    setdeleteDocument: (state, action) => {
      state.deleteDocument.push(action.payload.value);
    },
    cleardeleteDocument: (state, action) => {
      state.deleteDocument = [];
    },
    setResponseObject: (state, action) => {
      state.uploadedDocument = {
        ...state.uploadedDocument,
        [action.payload.key]: action.payload.value,
      };
    },
    setFaceObject: (state, action) => {
      state.facematch = {
        ...state.facematch,
        [action.payload.key]: action.payload.value,
      };
    },
    deleteUploadedDocument: (state, action) => {
      const uploaded_documents = { ...state.uploadedDocument };
      delete uploaded_documents[action.payload.key];
      state.uploadedDocument = uploaded_documents;
    },
    setAutofilled: (state, action) => {
      state.isAutofilled = action.payload;
    },
    ClearUploadedDocument: (state, action) => {
      state.uploadedDocument = {};
      files = [];
      state.fileData = {};
    },
    ClearDocuments: (state, action) => {
      state.documents = {};
    },
    setMultipleFileUpload: (state, action) => {
      state.multipleFileUpload = maxFile.push(action.payload);
      state.multipleFileUpload = [...maxFile];
    },
    setDocuments: (state, action) => {
      state.documents = {
        ...state.documents,
        [action.payload.key]: action.payload.value,
      };
    },
    setFetchedDocument: (state, action) => {
      state.documents = action.payload;
    },
    setFileData: (state, action) => {
      // files.push(action.payload.value)
      // state.fileData = [...files]
      if (!Object.keys(state.fileData).includes(action.payload.key)) {
        files = [];
      } else files = state.fileData?.[action.payload.key];
      state.fileData = {
        ...state.fileData,
        [action.payload.key]: [...files, action.payload.value],
      };
      files = state.fileData?.[action.payload.key];
    },
    setDeleteSameFile: (state, action) => {
      const { value } = action.payload;
      removeFiles = state.fileData?.[action.payload.key];
      removeFiles = removeFiles.filter((item) => item !== value);
      state.fileData = {
        ...state.fileData,
        [action.payload.key]: [...removeFiles],
      };
      if(state.multipleFileUpload.length > 0){
      const filePathToRemove =
        typeof value === "object" && value ? value : String(value);
      const updatedFiles = state.multipleFileUpload.filter(
        (item) => item?.acceptedFile?.file_path !== filePathToRemove
      );
      state.multipleFileUpload = updatedFiles;
      maxFile = maxFile.filter(
        (item) => item.acceptedFile?.file_path !== filePathToRemove
      );
    }
    },
    
    setVerificationResponse: (state, action) => {
      state.uploadVerificationResponses = {
        ...state.uploadVerificationResponses,
        [action.payload.key]: action.payload.value,
      };
    },
    deleteResponseObject: (state, action) => {
      const responses = { ...state.uploadVerificationResponses };
      delete responses[action.payload.key];
      state.uploadedDocument = responses;
    },
    ClearResponses: (state) => {
      state.uploadVerificationResponses = {};
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setUploadedDocument,
  setResponseObject,
  setAutofilled,
  ClearUploadedDocument,
  deleteUploadedDocument,
  setMultipleFileUpload,
  setDocuments,
  setFetchedDocument,
  setFileData,
  setDeleteSameFile,
  ClearDocuments,
  setdeleteDocument,
  cleardeleteDocument,
  setFaceObject,
  setVerificationResponse,
  deleteResponseObject,
  ClearResponses,
} = uploadDocumentReducer.actions;

export default uploadDocumentReducer.reducer;
